<template>
    <div class="recipes-item">
        <!--<router-link to="/recipe"></router-link>-->
        <router-link :to="{name: 'Recipe', params: { id: recipe.id }}" @click.native = "gaRecipe"></router-link>
        <img :src="recipe.image" alt="">
        <div class="recipes-info">
            <span class="recipes-num">{{index+1}}</span>
            <span class="recipes-name">{{recipe.title}}</span>
            <span class="recipes-portions">{{recipe.portion}} порции</span>
            <span class="recipes-time">{{recipe.time}} минут</span>
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap';

    export default {
        name: 'Recipes',
        props: ['recipe','index'],
        methods: {
            gaRecipe(){
                ga('send', 'event', 'click', 'show', 'Recipe Name: ' + this.recipe.title)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// Recipe.vue?74f0f611